import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { PromocaoUtilProvider } from '../../providers/promocao-util/promocao-util';
import { ProdutoListPage } from '../produto-list/produto-list';

@Component({
  selector: 'page-promocoes-list',
  templateUrl: 'promocoes-list.html',
})
export class PromocoesListPage {

  promocoes: Array<any>;

  range = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public server:SemovelProvider, private promocaoUtil:PromocaoUtilProvider) {
  }
 
  ionViewDidLoad() {
    this.promocoes = [];
    this.carregarDados();
  }

  carregarDados(){
    const request = { method: 'promocao/list' };

    this.server.postData(request, {range:this.range})
    .subscribe(
      data => {
        this.loadList(data.dados);
      },
      error => {
        this.server.showError(error);          
      }
    );
  }

  loadList(promocoes) {
    if(!promocoes) return;
    this.promocoes = promocoes;
  }

  verProduto(promocao){
    this.promocaoUtil.verProduto(promocao);
  }

  abrirTelaProdutos(){
    this.navCtrl.setRoot(ProdutoListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/promocoes-list/promocoes-list.ts